import { GET, POST, PATCH, DELETE, POST_LOGIN } from "../config";

// Autenticación
export const login = async (data) => {
  const response = await POST_LOGIN("accounts/users/login_complete/", data);
  return response;
};

export const signup = async (data) => {
  const response = await POST("accounts/users/create_and_assign/", data);
  return response;
};

// Gestión de contraseñas
export const change_password = async (data) => {
  const response = await POST(`accounts/users/change_password/`, data);
  return response;
};

export const forgot_password = async (data) => {
  const response = await POST_LOGIN("accounts/users/forgot_password/", data);
  return response;
};

// Reset de contraseña por administrador
export const reset_password = async (data) => {
  const response = await POST("accounts/users/reset_password/", data);
  return response.data;
};

export const reset_password_confirm = async (data) => {
  const response = await POST_LOGIN(
    "accounts/users/reset_password_confirm/",
    data
  );
  return response;
};

// CRUD de usuarios
export const list = async (page = 1, branch_ids = [], context = null, search = "") => {
  let url = `accounts/users/?page=${page}`;
  if (branch_ids && branch_ids.length > 0) {
    url += `&branch_ids=${branch_ids.join(",")}`;
  }
  if (context) {
    url += `&context=${context}`;
  }
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await GET(url);
  return response.data;
};

// Específico para asignación de productos (solo medidores)
export const list_for_product_assignment = async (page = 1) => {
  const response = await GET(
    `accounts/users/for-product-assignment/?page=${page}`
  );
  return response.data;
};

export const retrieve = async (userId) => {
  const response = await GET(`accounts/users/${userId}/`);
  return response.data;
};

export const get_profile = async (user_id) => {
  const response = await GET(`accounts/users/${user_id}/`);
  return response.data;
};

// Perfil del usuario autenticado
export const get_my_profile = async () => {
  const response = await GET("accounts/users/my-profile/");
  return response.data;
};

export const update_my_profile = async (data) => {
  const response = await PATCH("accounts/users/my-profile/", data);
  return response.data;
};

// Asignación de productos a usuarios medidores
export const get_user_product_assignment = async (user_id) => {
  const response = await GET(`accounts/users/${user_id}/product-assignment/`);
  return response.data;
};

export const update_user_product_assignment = async (user_id, data) => {
  const response = await PATCH(
    `accounts/users/${user_id}/product-assignment/`,
    data
  );
  return response.data;
};

/**
 * Listar usuarios con rol METER
 * @param {Object} filters - Filtros opcionales
 * @param {boolean} filters.has_assigned_product - Filtrar por si tiene producto asignado
 * @returns {Promise<Object>} Lista de usuarios medidores con sus sucursales y productos
 */
export const list_meters = async (filters = {}) => {
  let url = "accounts/users/meters/";
  
  const params = new URLSearchParams();
  
  if (filters.has_assigned_product !== undefined) {
    params.append("has_assigned_product", filters.has_assigned_product);
  }
  
  const queryString = params.toString();
  if (queryString) {
    url += `?${queryString}`;
  }
  
  const response = await GET(url);
  return response.data;
};

export const create = async (data) => {
  const response = await POST("accounts/users/", data);
  return response.data;
};

export const update = async (user_id, data) => {
  const response = await PATCH(`accounts/users/${user_id}/`, data);
  return response.data;
};

export const destroy = async (user_id) => {
  const response = await DELETE(`accounts/users/${user_id}/`);
  return response.data;
};

// Gestión de roles y estado
export const toggle_user_status = async (data) => {
  // Nota: Este método es legacy, usar toggle_branch_assignment_status directamente
  // con assignment_id en lugar de user_id y branch_id
  console.warn(
    "toggle_user_status is deprecated, use toggle_branch_assignment_status directly"
  );
  const response = await POST(
    "accounts/users/toggle_branch_assignment_status/",
    data
  );
  return response;
};

export const change_user_role = async (data) => {
  const response = await POST("accounts/users/change_user_role/", data);
  return response;
};

// Gestión específica de asignaciones de sucursales
export const toggle_branch_assignment_status = async (data) => {
  const response = await POST(
    "accounts/users/toggle_branch_assignment_status/",
    data
  );
  return response;
};

export const change_assignment_role = async (data) => {
  const response = await POST("accounts/users/change_assignment_role/", data);
  return response;
};

// Asignar usuario a sucursal (para usuarios sin sucursal)
export const assign_to_branch = async (data) => {
  const response = await POST("accounts/users/assign_to_branch/", data);
  return response;
};

// Generar contraseña
export const generate_password = async (user_id) => {
  const response = await POST(`accounts/users/${user_id}/generate-password/`);
  return response;
};
